import { render, staticRenderFns } from "./visitorArea.vue?vue&type=template&id=2f77afbd&scoped=true&"
import script from "./visitorArea.vue?vue&type=script&lang=tsx&"
export * from "./visitorArea.vue?vue&type=script&lang=tsx&"
import style0 from "./visitorArea.vue?vue&type=style&index=0&id=2f77afbd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f77afbd",
  null
  
)

export default component.exports